import styled from "styled-components";
import { theme } from "../theme";

export const StyledProfileDetailsImage = styled.picture`
	position: relative;
	background: ${theme.color.blue2};
	width: 12rem;
	height: 12rem;
	border-radius: 50%;
	display: flex;
	overflow: hidden;

	& > img {
		min-width: 100%;
		min-height: 100%;
		object-fit: cover;
	}

	button {
		border: none;
		background: transparent;
		outline: none;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		right: 1px;
		bottom: 1px;
	}
`;
